import * as bootstrap from 'bootstrap'

import DummyText from "./utils/DummyText";
import ResponsiveHelper from "./utils/ResponsiveHelper";
import mobile from "is-mobile";
import vhCheck from 'vh-check'
import Cookies from "js-cookie";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Slider from "./components/Slider";
import Section from "./components/Section";

import { convertRemToPixels } from "./utils/WWWFunctions";

import JSShare from "js-share";

export default class Common {
  constructor() {
    window.addEventListener("resize", () => this.resize());

    this.updateVhCssVar()

    this.headerNoHide = false

    this.handleFsHc()

    this.handleNavAction()
    // this.handleHeader()
    this.handleHeaderSearch()
    this.handleHeaderShare()

    this.handleNoteBar()
    this.handleNotice()

    this.handleScrollFixBg()

    this.handleSliders()
    this.handleSectionModules()
    this.handleContentModules()

    this.handleScrollTopBtn()
    this.handleFormFilter()

  }

  init() {
  }
  updateVhCssVar() {
    const vhObj = vhCheck()
    const header = document.querySelector('header')
    const footer = document.querySelector('footer')
    document.body.style.setProperty("--header-height", `${header.offsetHeight}px`);
    document.body.style.setProperty("--footer-height", `${footer.offsetHeight}px`);
  }
  fixVhCssVar() {
    const vhObj = vhCheck()
  }

  handleFsHc() {
    const fs_btns = document.querySelectorAll('.nav--select-fonts a')
    fs_btns.forEach((item, i) => {
      item.addEventListener('click', (e) => {
        e.preventDefault()
        Cookies.set("fs", e.target.dataset.size, { expires: 30 });
        // window.location.href = `${e.target.href}?fs=${e.target.dataset.size}`
        window.location.href = `${e.target.href}`
      })
    });

    const hc_btn = document.querySelector('.nav--select-hc a')
    hc_btn.addEventListener('click', (e) => {
      e.preventDefault()
      if (Cookies.get('hc')) {
        Cookies.remove('hc')
      } else {
        Cookies.set("hc", 1, { expires: 30 });
      }
      window.location.href = `${e.target.href}`
    })
  }

  handleNavAction() {
    const el_nav = document.querySelector('nav')
    document.querySelectorAll('[js-nav-open]').forEach((item, i) => {
      item.addEventListener('click', () => {
        el_nav.classList.add('active')
      })
    });
    document.querySelectorAll('[js-nav-close]').forEach((item, i) => {
      item.addEventListener('click', () => {
        el_nav.classList.remove('active')
      })
    });
  }

  handleHeader() {
    const el_header = document.querySelector('header')
    let headerBottom = el_header.offsetTop + el_header.offsetHeight;
    let prevScrollpos = window.pageYOffset;

    const sidebar = document.querySelector('.contents-sidebar-menu')
    let _this = this
    window.onscroll = function() {
      let currentScrollPos = window.pageYOffset;

      /* if scrolling down, let it scroll out of view as normal */
      if (prevScrollpos <= currentScrollPos && currentScrollPos > headerBottom && !_this.headerNoHide) {
        gsap.to(el_header, {
          y: -headerBottom,
          duration: .5
        })

        const event = new CustomEvent("handleContentSidebar", {
          detail: {
            type: 'top',
            val: -headerBottom
          }
        });
        // document.dispatchEvent(event);
      }
      /* otherwise if we're scrolling up, fix the nav to the top */
      else {
        gsap.to(el_header, {
          y: 0,
          duration: .5
        })

        const event = new CustomEvent("handleContentSidebar", {
          detail: {
            type: 'top',
            val: 0
          }
        });
        // document.dispatchEvent(event);
      }

      prevScrollpos = currentScrollPos;
    }
  }

  handleHeaderSearch() {
    let search_open = false
    const el_search_btn = document.querySelector('[js-header-search-btn]')
    const el_search_close = document.querySelector('[js-header-search-close]')
    const el_search = document.querySelector('[js-header-search]')

    mobiscroll.datepicker(document.querySelector('.filterHeader #date-start-end'), {
      touchUi: false,
      select: 'range',
      startInput: document.querySelector('.filterHeader #hs-date-start'),
      endInput: document.querySelector('.filterHeader #hs-date-end'),
    });

    el_search_btn.addEventListener('click', () => {
      if (search_open) {
        return
      }
      this.headerNoHide = true
      gsap.set(el_search, {
        display: 'grid',
        y: -40,
        opacity: 0
      })
      gsap.to(el_search, {
        y: 0,
        opacity: 1,
        duration: .35,
        onComplete: () => {
          search_open = true
        },
      })
    })

    el_search_close.addEventListener('click', () => {
      this.headerNoHide = false
      gsap.to(el_search, {
        y: -40,
        opacity: 0,
        duration: .35,
        onComplete: () => {
          search_open = false
          gsap.set(el_search, {
            display: 'none',
          })
        },
      })
    })
  }

  handleHeaderShare() {
    let share_open = false
    const el_share_btn = document.querySelector('[js-header-share]')
    const el_share = document.querySelector('[js-share-icons]')

    el_share_btn.addEventListener('click', () => {
      if (share_open) {
        return
      }

      gsap.set(el_share, {
        display: 'flex',
        maxHeight: 0,
        opacity: 1
      })
      const h = el_share.querySelector('.share-icons--wrap').offsetHeight
      gsap.to(el_share, {
        maxHeight: `${h}px`,
        opacity: 1,
        duration: .35,
        onComplete: () => {
          share_open = true
        },
      })
    })

    document.body.addEventListener('click', (e) => {
      if (e.target == el_share_btn) {
        return
      }
      const h = el_share.querySelector('.share-icons--wrap').offsetHeight
      gsap.to(el_share, {
        maxHeight: 0,
        opacity: 1,
        duration: .35,
        onComplete: () => {
          share_open = false
          gsap.set(el_share, {
            display: 'none',
          })
        },
      })
    })

    document.querySelectorAll('.share-icons--wrap button').forEach((item, i) => {
      item.addEventListener('click', function share(e) {
        JSShare.options.url = window.location.href
        return JSShare.go(this)
      });
    });

  }

  handleNoteBar() {
    const el_noteBar = document.querySelector('.note-bar')
    if (el_noteBar) {
      document.querySelector('[js-note-bar-close]').addEventListener('click', () => {
        gsap.to(el_noteBar, {
          y: '-100%',
          duration: .35,
          onComplete: () => {
            el_noteBar.remove()
          },
        })
      })
    }
  }

  handleNotice() {
    const el_notice = document.querySelector('#noticeModal')

    if (el_notice) {
      const noticeModal = new bootstrap.Modal(el_notice, {
        keyboard: false
      })

      noticeModal.show()
    }
  }

  handleSliders() {
    const sliders = document.querySelectorAll('.www-slider')
    if (sliders.length) {
      sliders.forEach((item, i) => {
        const slider = new Slider(item)
        slider.init()
      });
    }
  }

  handleSectionModules() {
    const sections = document.querySelectorAll('.section-part')
    if (sections.length) {
      sections.forEach((item, i) => {
        const section = new Section(item)
        section.init()
      });
    }
  }

  handleScrollFixBg() {
    const figBg = document.querySelector('.scroll-fix-bg')

    if (figBg) {
      ScrollTrigger.create({
        trigger: figBg,
        start: `top 0`,
        end: () => {
          // console.log(figBg.get);
          // let h = document.querySelector('.page-container').offsetHeight - figBg.offsetHeight
          let h = figBg.parentNode.offsetHeight - figBg.offsetHeight
          if (figBg.classList.contains('_2') || figBg.classList.contains('_3')) {
            h = figBg.parentNode.offsetHeight - figBg.offsetHeight + document.querySelector('header').offsetHeight
          }
          // console.log(h);
          return `+=${h}`
        },
        pin: true,
        pinSpacing: false,
        // markers: true,
      });
    }
  }

  handleContentModules() {
    const sidebar = document.querySelector('.contents-sidebar-menu')
    const contents = document.querySelector('.content_modules')

    let inActive = false
    let _this = this

    if (sidebar && contents) {
      ScrollTrigger.matchMedia({
        "(min-width: 769px)": function () {
          // console.log('d');
          ScrollTrigger.create({
            trigger: sidebar,
            start: `top ${document.querySelector('header').offsetHeight + convertRemToPixels(2)}px`,
            end: () => {
              let h = contents.offsetHeight - sidebar.offsetHeight
              return `+=${h}`
            },
            pin: true,
            // markers: true,
            onEnter: () => {
              console.log('onEnter');
              inActive = true
            },
            onEnterBack:() => {
              console.log('onEnterBack');

            },
            onLeave: () => {
              console.log('onLeave');
            },
            onLeaveBack: () => {
              console.log('onLeaveBack');
              inActive = false
            }
          });
        },
        "(max-width: 768px)": function () {

        },
      })

      sidebar.querySelectorAll('a').forEach((item, i) => {
        item.addEventListener('click', (e) => {
          e.preventDefault()
          gsap.to(window, {
            duration: .5,
            scrollTo: {
              y: `#section-${item.dataset.index}`,
              offsetY: document.querySelector('header').offsetHeight + convertRemToPixels(2)
            }
          });
        })
      });

      document.addEventListener('handleContentSidebar', (e) => {
        switch (e.detail.type) {
          case 'top':
            if (inActive) {
              gsap.to(sidebar, {
                y: e.detail.val,
                duration: .5
              })
            }
            break;
          default:

        }
      })
    }
  }

  convertRemToPixels(rem) {
    return rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
  }

  handleScrollTopBtn() {
    const scrollTopBtn = document.querySelector('.scroll-top-btn')
    scrollTopBtn.addEventListener('click', () => {
      gsap.to(window, {
        duration: .5,
        scrollTo: 0
      })
    })
    ScrollTrigger.matchMedia({
      "(min-width: 769px)": function () {

      },
      "(max-width: 768px)": function () {
        ScrollTrigger.create({
          trigger: document.body,
          start: `${window.innerHeight}px top`,
          end: () => {
            return `+=${document.body.offsetHeight - window.innerHeight}`
          },
          // markers: true,
          onEnter: () => {
            console.log('onEnter');
            gsap.to(scrollTopBtn, {
              opacity: 1,
              duration: .35,
              onComplete: () => {
                gsap.set(scrollTopBtn, {
                  pointerEvents: 'all',
                })
              },
            })
          },
          onEnterBack:() => {
            console.log('onEnterBack');
          },
          onLeave: () => {
            console.log('onLeave');
          },
          onLeaveBack: () => {
            console.log('onLeaveBack');
            gsap.set(scrollTopBtn, {
              pointerEvents: 'none',
            })
            gsap.to(scrollTopBtn, {
              opacity: 0,
              duration: .35,
            })
          }
        });
      },
    })
  }

  handleFormFilter() {
    const el_parent_checkboxs = document.querySelectorAll('form .item._locations, form .item._categories')

    el_parent_checkboxs.forEach((el_parent, i) => {
      const checkboxs = el_parent.querySelectorAll('input[type="checkbox"]:not(.sub-parent)')
      const checkbox_for_all = el_parent.querySelector('input[type="checkbox"][value="-1"]')
      const checkbox_sub_parents = el_parent.querySelectorAll('input.sub-parent[type="checkbox"]')

      checkboxs.forEach((checkbox, i) => {
        checkbox.addEventListener('change', (e) => {
          const val = e.target.value
          const checked = e.currentTarget.checked
          console.log(val, checked);
          switch (val) {
            case '-1':
              if (checked) {
                [...checkboxs, ...checkbox_sub_parents].forEach((item, i) => {
                  item.checked = true
                });

              } else {
                [...checkboxs, ...checkbox_sub_parents].forEach((item, i) => {
                  item.checked = false
                });
              }
              break;
            default:
              const sub_parent = e.target.parentNode.parentNode.querySelector('input.sub-parent[type="checkbox"]')
              if (checked) {
                const childs = e.target.parentNode.parentNode.querySelectorAll('input[type="checkbox"]:not(.sub-parent)')
                const childs_checked = e.target.parentNode.parentNode.querySelectorAll('input[type="checkbox"]:checked:not(.sub-parent)')
                const el_checked = el_parent.querySelectorAll('input[type="checkbox"]:checked:not([value="-1"], .sub-parent)')
                if (el_checked.length == checkboxs.length - 1) {
                  checkbox_for_all.checked = true
                }

                if (childs_checked.length == childs.length) {
                  if (sub_parent) {
                    sub_parent.checked = true
                  }

                }
              } else {
                checkbox_for_all.checked = false
                if (sub_parent) {
                  sub_parent.checked = false
                }

              }
              break;
          }
        })
      });

      checkbox_sub_parents.forEach((checkbox_lbl, i) => {
        checkbox_lbl.addEventListener('change', (e) => {
          const childs = e.target.parentNode.parentNode.querySelectorAll('input[type="checkbox"]:not(.sub-parent)')
          childs.forEach((item, i) => {
            item.checked = e.currentTarget.checked
          });
          let el_checked = el_parent.querySelectorAll('input[type="checkbox"]:checked:not([value="-1"], .sub-parent)')
          if (el_checked.length == checkboxs.length - 1) {
            checkbox_for_all.checked = true
          } else {
            checkbox_for_all.checked = false
          }
        })
      });


    });


  }

  resize() {
    this.updateVhCssVar()
  }
}
